import home from './home/home';

const componentModule = angular.module('app.layouts', [
  home
])
  .name;

export default componentModule;
